const unique = arr => [...new Set(arr)];

const selectWhereKeyEqualsValue = (key, values) => record =>
  values.includes(`${record[key]}`);

const selectDistinct = (arr, key) =>
  unique(arr.filter(r => r).map(record => record[key])).filter(e => e);

const filterData = (arr, filters) => {
  let outData = [...arr];
  Object.keys(filters).forEach(filterField => {
    if (filters[filterField].length) {
      outData = outData.filter(
        selectWhereKeyEqualsValue(filterField, filters[filterField])
      );
    }
  });

  return outData;
};
const getDropdownOptions = (data, filters, field, filtersWithDropDowns) => {
  const filtersWithoutField = { ...filters };

  // ignore filters from non-drop down data, cause we dont have data for things like hakai id
  Object.keys(filtersWithoutField).forEach(e => {
    if (!filtersWithDropDowns.includes(e)) delete filtersWithoutField[e];
  });

  // if we are building drop down data for survey for example, dont let survey's chip affect itself
  delete filtersWithoutField[field];

  return selectDistinct(filterData(data, filtersWithoutField), field).map(e =>
    `${e}`.toUpperCase()
  );
};

export default getDropdownOptions;
